export default __webpack_public_path__ + "static/media/425.144e16c7.gif";